import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { CerSessionService, CerSessionStateType } from 'src/cer/cer-session/cer-session.service';
import { CerPromptService } from '@ui/cer-ui-prompt.service';

@Injectable({
  providedIn: 'root'
})
export class CerAuthorizePromptService implements OnDestroy {
  private subscriptionManager$: Subscription = new Subscription();

  constructor(private session: CerSessionService, private ui: CerPromptService) {
    this.subscriptionManager$.add(
      this.session.sessionState$.subscribe(state => this.sessionStatePrompt(state))
    );
  }

  ngOnDestroy(): void {
    this.subscriptionManager$.unsubscribe();
  }

  public errorNoAccess(routeTitle: string) {
    var title: string = this.session.environment.title$.getValue() + ' - Ingen adgang';
    var userName: string = this.session.user.name();
    const content = [
      `Bruger '${userName}' har ikke adgang til funktionen '${routeTitle}'.`,
      'Afvent eller kontakt administrator.'
    ];
    this.ui.error(content, title);
  }

  public sessionStatePrompt(state: CerSessionStateType) {
    switch (state) {
      case 'paused':
        this.sessionPausedPrompt();
        break;
      case 'expired':
        this.sessionExpiredPrompt();
        break;
      case 'noRolesActive':
        this.promptNoRolesActive();
    }
  }

  private promptNoRolesActive() {
    const title: string = this.session.environment.title$.getValue() + ' - Adgang ikke tildelt';
    const userName: string = this.session.user.name();
    const content = `Bruger '${userName}' er ikke tildelt nogen roller i ${title}.`;
    this.ui.info(content, title).then(
      ok => {
        this.session.deactivate();
      }
    );
  }

  private sessionPausedPrompt() {
    // Ask for user de reactivate session
    var title: string = this.session.environment.title$.getValue();
    if (this.session.isAuthenticated()) {
      this.ui.info(title + ' er på  pause. Fortsæt?', "Pause").then(
        ok => {
          this.session.deactivate();
        }
      );
    }
  }

  private sessionExpiredPrompt() {
    // Ask for user de reactivate session
    var title: string = this.session.environment.title();
    if (this.session.isAuthenticated()) {
      this.ui.info(title + ' login er udløbet. Fortsæt?', "Logind udløbet").then(
        ok => {
          this.session.expire();
        }
      );
    }
  }
}
